import React from 'react';

// Monday-to-Friday as a horizontal track on desktop, a vertical rail on mobile.
export function WeekTimeline({
  week
}: {
  week: {
    day: string;
    focus: string;
  }[];
}) {
  return <ol className="relative grid gap-6 md:grid-cols-5 md:gap-4" data-id="element-305" data-mp="2q7exz9o6um79">
      <span className="absolute left-[7px] top-2 h-[calc(100%-16px)] w-0.5 bg-line md:left-0 md:top-[7px] md:h-0.5 md:w-full" aria-hidden="true" data-id="element-306" data-mp="2q87wjnczu5eb" />
      {week.map((day, index) => <li key={day.day} className="relative pl-8 md:pl-0 md:pt-10" data-id="element-307" data-mp="1yhtquef4vzdq" data-mpi={index}>
          <span className={`absolute left-0 top-1.5 h-4 w-4 rounded-full border-[3px] md:top-0 ${index === week.length - 1 ? 'border-brand bg-brand' : 'border-brand bg-white'}`} aria-hidden="true" data-id="element-308" data-mp="22h2klja6bx9a" />
          <p className="type-h3 text-ink" data-id="element-309" data-mp="2c9i3citaopv8">{day.day}</p>
          <p className="mt-2 type-card-desc text-body" data-id="element-310" data-mp="1erhzouugmpxd">{day.focus}</p>
        </li>)}
    </ol>;
}